import OrderConstants from '../constants/OrderConstants';
import ShoppingCartConstants from '../constants/ShoppingCartConstants';
import PaginatedStore from './PaginatedStore';
import Order from '../models/Order';

class OrderStore extends PaginatedStore {
  static storeName = 'OrderStore';
  static handlers = {
    [OrderConstants.FETCH_ORDER_START]                     : 'fetchEntityStart',
    [OrderConstants.FETCH_ORDER_SUCCESS]                   : 'fetchEntitySuccess',
    [OrderConstants.FETCH_ORDER_FAILURE]                   : 'fetchEntityFailure',
    [OrderConstants.LIST_ORDERS_START]                     : 'listEntitiesStart',
    [OrderConstants.LIST_ORDERS_SUCCESS]                   : 'listEntitiesSuccess',
    [OrderConstants.LIST_ORDERS_FAILURE]                   : 'listEntitiesFailure',
    [ShoppingCartConstants.CHECKOUT_SHOPPING_CART_SUCCESS] : 'checkoutSuccess'
  };
  static defaultPagination = { offset: 0, limit: 10 };
  static defaultSorter = { key: 'submitted_at', direction: 'desc' };
  static entityModel = Order;

  checkoutSuccess(data) {
    let { order } = data;
    this.currentEntityId = order.id;
    this.fetchEntitySuccess(order);
  }
}

export default OrderStore;



// WEBPACK FOOTER //
// banquet/stores/OrderStore.js